import {ISearchEpg} from "../../../interfaces/ISearchEpg.ts";
import {useState} from "react";
import DateHelper from "../../../helpers/dateHelper.ts";
import AccountFavoritePreviousNextItem from "./widgets/AccountFavoritePreviousNextItem.tsx";
import AccountFavoriteCurrentItem from "./widgets/AccountFavoriteCurrentItem.tsx";
import {useChannelsService} from "../../../hooks/useChannelsService.tsx";
import {XMarkIcon} from "@heroicons/react/24/solid";

interface IProps {
    name: string;
    favoriteDetails?: ISearchEpg
}

const initialTabs = [
    {name: 'Poprzednio', href: '#', current: false},
    {name: 'Aktualnie', href: '#', current: true},
    {name: 'Następne', href: '#', current: false}
]

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

const AccountFavoriteDetails = ({name, favoriteDetails}: IProps) => {
    const channelService = useChannelsService();
    const [tabs, setTabs] = useState(initialTabs);

    const handleTabClick = (clickedName: string) => {
        setTabs(prev =>
            prev.map(tab => ({
                ...tab,
                current: tab.name === clickedName,
            }))
        );
    };

    const previousEpg = favoriteDetails?.epgItems
        .filter((epgItem) => epgItem.timeTo < DateHelper.DateTimeNowUnixTimestamp()).sort((a, b) => b.time - a.time);

    const currentEpg = favoriteDetails?.epgItems
        .filter((epgItem) => (epgItem.time < DateHelper.DateTimeNowUnixTimestamp()) && (epgItem.timeTo > DateHelper.DateTimeNowUnixTimestamp()));

    const nextEpg = favoriteDetails?.epgItems
        .filter((epgItem) => epgItem.time > DateHelper.DateTimeNowUnixTimestamp());
    console.log(previousEpg);
    return (
        <div className={"relative h-full flex flex-col"}>
            <div className="border-b border-white/10">
                <nav aria-label="Tabs" className="-mb-px flex">
                    {tabs.map((tab) => (
                        <button
                            key={tab.name}
                            onClick={() => {
                                handleTabClick(tab.name);
                            }}
                            aria-current={tab.current ? 'page' : undefined}
                            className={classNames(
                                tab.current
                                    ? 'border-[#008DD2] text-[#008DD2]'
                                    : 'border-transparent text-neutral-400 hover:border-white/20 hover:text-neutral-300',
                                'w-1/3 border-b-2 px-1 py-4 text-center text-sm font-medium transition',
                            )}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>
            <div className={"overflow-y-auto "}>
                {(tabs.find((tab) => tab.current)?.name == initialTabs[0].name) && <>
                    {previousEpg?.length === 0 &&
                        <div className={"text-center py-2 text-neutral-300"}>
                            <p>Brak transmisji</p>
                        </div>}
                    {previousEpg && previousEpg?.length > 0 && previousEpg?.map((epg, index) =>
                        <AccountFavoritePreviousNextItem key={epg.id} item={epg}
                                                         channel={channelService.channels.find(channel => channel.ch_id == epg.channelId)}/>
                    )}
                </>}
                {(tabs.find((tab) => tab.current)?.name == initialTabs[1].name) && <>
                    {currentEpg?.length === 0 &&
                        <div className={"text-center py-2 text-neutral-300"}>
                            Brak transmisji
                        </div>}
                        {currentEpg && currentEpg?.length > 0 && currentEpg?.map((epg, index) =>
                            <AccountFavoriteCurrentItem key={epg.id} favorite={epg}
                                                        channel={channelService.channels.find(channel => channel.ch_id == epg.channelId)}/>
                        )}
                </>}
                {(tabs.find((tab) => tab.current)?.name == initialTabs[2].name) && <>
                    {nextEpg?.length === 0 &&
                        <div className={"text-center py-2 text-neutral-300"}>
                            Brak transmisji
                        </div>}
                    {nextEpg && nextEpg?.length > 0 && nextEpg?.map((epg, index) =>
                        <AccountFavoritePreviousNextItem key={epg.id} item={epg}
                                                         channel={channelService.channels.find(channel => channel.ch_id == epg.channelId)}/>
                    )}
                </>}
            </div>
        </div>
    );
};

export default AccountFavoriteDetails;